// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2kDs5","errorLogs":"EditorFooter_errorLogs__1pcO5"};